var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.002,
    viewBox: "0 0 20 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: 0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_3130",
    "data-name": "\\u7EC4 3130",
    transform: "translate(-203 -16.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8054\\u5408_3",
    "data-name": "\\u8054\\u5408 3",
    className: "cls-1",
    d: "M12.291,20A2.3,2.3,0,0,1,10,17.708V12.292A2.294,2.294,0,0,1,12.292,10h5.417A2.293,2.293,0,0,1,20,12.293v5.416A2.294,2.294,0,0,1,17.708,20Zm.209-6.043a.626.626,0,0,0,.624.624H13.4A3.134,3.134,0,0,0,13.919,16a9.046,9.046,0,0,1-.935.27.625.625,0,0,0,.141,1.234.613.613,0,0,0,.143-.017,7.469,7.469,0,0,0,1.733-.6,7.451,7.451,0,0,0,1.733.6.625.625,0,1,0,.285-1.217A9.16,9.16,0,0,1,16.082,16a3.175,3.175,0,0,0,.522-1.414h.271a.625.625,0,0,0,0-1.25h-1.25v-.208a.626.626,0,0,0-1.251,0v.207h-1.25A.626.626,0,0,0,12.5,13.958ZM5.831,16.667a2.5,2.5,0,0,1-2.5-2.5v-.834a.834.834,0,1,1,1.669,0H5v.834A.833.833,0,0,0,5.834,15h.833a.834.834,0,1,1,.065,1.666.631.631,0,0,1-.065,0H5.831Zm8.821-2.083h.7a1.606,1.606,0,0,1-.348.771A1.606,1.606,0,0,1,14.652,14.584ZM2.291,10A2.294,2.294,0,0,1,0,7.707V2.291A2.293,2.293,0,0,1,2.291,0H7.709A2.294,2.294,0,0,1,10,2.291V7.708A2.3,2.3,0,0,1,7.707,10ZM5.416,6.25v.624a.625.625,0,1,0,1.25,0V4.165a1.668,1.668,0,0,0-3.335,0V6.875a.625.625,0,1,0,1.25,0V6.25ZM15,6.667V5.832A.835.835,0,0,0,14.166,5h-.834a.834.834,0,0,1,0-1.667h.834a2.5,2.5,0,0,1,2.5,2.5v.835a.833.833,0,1,1-1.666,0ZM4.584,5V4.165a.416.416,0,1,1,.833,0V5Z",
    transform: "translate(203 16.999)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_279",
    "data-name": "\\u77E9\\u5F62 279",
    className: "cls-2",
    width: 20,
    height: 20,
    transform: "translate(203 17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.7c40e5b7f4bb049b7bb5b75ee3f4145b.svg";
export { ForwardRef as ReactComponent };